export default __webpack_public_path__ + "static/media/13.26705ce8.png";